/* eslint-disable @typescript-eslint/no-require-imports */
import type React from "react";

import isIPad from "$src/core/utils/device/is-ipad";
import CustomPlatform from "$src/core/utils/platform/platform";

import type { EPGChannelSelectorProps } from "./types";

export type {
  EPGChannelSelectorChannel,
  EPGChannelSelectorProps,
} from "./types";

export default CustomPlatform.select<() => React.FC<EPGChannelSelectorProps>>({
  tv: () => require("./EPGChannelSelector.tv").default,
  web: () => require("./EPGChannelSelector.web").default,
  // The web grouped pills go with the web grid a tablet now renders.
  ios: () =>
    isIPad
      ? require("./EPGChannelSelector.web").default
      : require("./EPGChannelSelector").default,
  default: () => require("./EPGChannelSelector").default,
})();
